import { useEffect, useState } from "react";
import { decodeContact, maskFor } from "@/lib/contactProtect";

type Props = {
  /** contactProtect.CONTACT içindeki kodlanmış değer. */
  encoded: string;
  /** tel: bağlantısı için boşluksuz kodlanmış değer. Yalnızca telefonda. */
  encodedRaw?: string;
  className?: string;
};

/**
 * E-posta adresini yalnızca tarayıcıda çözüp mailto bağlantısı olarak basar.
 * Prerender edilmiş HTML'de yer tutucu görünür, gerçek adres görünmez.
 */
export function ProtectedEmail({ encoded, className }: Props) {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(decodeContact(encoded));
  }, [encoded]);

  if (!value) {
    return <span className={className}>{maskFor("email")}</span>;
  }

  return (
    <a href={`mailto:${value}`} className={className}>
      {value}
    </a>
  );
}

/**
 * Telefon numarasını yalnızca tarayıcıda çözüp tel bağlantısı olarak basar.
 * Görünen metin okunaklı biçimi, bağlantı boşluksuz biçimi kullanır.
 */
export function ProtectedPhone({ encoded, encodedRaw, className }: Props) {
  const [value, setValue] = useState("");
  const [raw, setRaw] = useState("");

  useEffect(() => {
    setValue(decodeContact(encoded));
    setRaw(decodeContact(encodedRaw ?? encoded).replace(/\s/g, ""));
  }, [encoded, encodedRaw]);

  if (!value) {
    return <span className={className}>{maskFor("phone")}</span>;
  }

  return (
    <a href={`tel:${raw}`} className={className}>
      {value}
    </a>
  );
}

/**
 * Firestore'dan (company_settings) gelen düz değerler için. Bu değerler
 * istemci tarafında yüklendiği için zaten prerender HTML'ine girmez, ancak
 * hidrasyon öncesi boş kalmaması ve mailto/tel bağlantısı kazanması için
 * aynı bileşenden geçirilir.
 */
export function PlainProtected({
  value,
  kind,
  className,
}: {
  value: string;
  kind: "email" | "phone";
  className?: string;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready || !value) {
    return <span className={className}>{maskFor(kind)}</span>;
  }

  const href = kind === "email" ? `mailto:${value}` : `tel:${value.replace(/\s/g, "")}`;
  return (
    <a href={href} className={className}>
      {value}
    </a>
  );
}
